var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"episode8_item",class:(_vm.mode + " count" + _vm.count)},[_c('div',{staticClass:"message"},_vm._l((_vm.messages),function(message,k){return _c('div',{key:k},[_vm._v(_vm._s(message))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }